import { DashboardComponent } from './dashboard/dashboard.component';
import { LoginComponent } from './login/login.component';
import { VechicleComponent } from './vechicle/vechicle.component';

export const    VendorDeclaration = [
    LoginComponent,
    DashboardComponent,
    VechicleComponent
];
